import { render, staticRenderFns } from "./CustomerSocialInsurance.vue?vue&type=template&id=4d3d3a6f"
import script from "./CustomerSocialInsurance.vue?vue&type=script&lang=js"
export * from "./CustomerSocialInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports